export default {
	DISABLED: 'disabled',
	SHOWING: 'showing',
}
